import { Card } from "@/components/ui/card";
import { IconBox } from "./IconBox";
import { Body, Heading } from "@hypercard/web-components";
import { Icon as PhIcon } from "@phosphor-icons/react";
import { twMerge } from "@/utils/utils";

const containerClassName =
  "flex flex-grow flex-col items-center justify-center p-[100px] text-center";

type Props = {
  Icon: PhIcon | (({ className }: { className: string }) => JSX.Element);
  header: string;
  body?: string;
  children?: React.ReactNode;
  cardClassName?: string;
};

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="mt-4 flex w-full flex-grow flex-col pb-16">
    <div className="flex flex-grow items-stretch justify-center">
      {children}
    </div>
  </div>
);

const Content = ({ Icon, header, body, children }: Props) => {
  return (
    <>
      <IconBox>
        <Icon className="size-10" />
      </IconBox>
      <Heading size="lg" weight="regular" className="my-3">
        {header}
      </Heading>
      <Body
        size="md"
        weight="regular"
        className="whitespace-pre text-wrap text-slate"
      >
        {body}
      </Body>
      {children}
    </>
  );
};

export const NoResultsCard = (props: Props) => {
  return (
    <Wrapper>
      <Card className={twMerge(containerClassName, props.cardClassName)}>
        <Content {...props} />
      </Card>
    </Wrapper>
  );
};

export const NoResults = (props: Props) => {
  return (
    <Wrapper>
      <div className={containerClassName}>
        <Content {...props} />
      </div>
    </Wrapper>
  );
};
